import {
  Account,
  AccountSubscriber,
  AccountSubscriberFilters,
  QueryResult,
  User,
} from '../../types';
import api from '../../api';
import isGranted from '../../auth/isGranted';

export default {
  find(id: string): Promise<AccountSubscriber> {
    if (!isGranted('FIND_ACCOUNT_SUBSCRIBER')) return Promise.reject();
    return api
      .get(`account-subscribers/${id}`)
      .then(response => response.data);
  },
  findSubscribers(filters: AccountSubscriberFilters): Promise<QueryResult> {
    if (!isGranted('FIND_ACCOUNT_SUBSCRIBERS')) return Promise.reject();
    return api
      .get('account-subscribers', { params: filters })
      .then(response => response.data);
  },
  findUnsubscribedUsers(clientId: string): Promise<User[]> {
    if (!isGranted('FIND_UNSUBSCRIBED_USERS')) return Promise.reject();
    return api
      .get(`accounts/${clientId}/unsubscribed-users`)
      .then(response => response.data);
  },
  findByUser(filters: AccountSubscriberFilters): Promise<QueryResult> {
    return api
      .get('account-subscribers', { params: filters })
      .then(response => response.data);
  },
  findUnsubscribedClients(userId: string): Promise<Account[]> {
    return api
      .get(`users/${userId}/unsubscribed-clients`)
      .then(response => response.data);
  },
};
